import { createApp } from 'vue';
import App from './App.vue';
import './assets/global.css';

const app = createApp(App);
app.mount('#app');

if (
  typeof __APP_BUILD_MODE__ !== 'undefined' &&
  __APP_BUILD_MODE__ === 'production' &&
  'serviceWorker' in navigator
) {
  window.addEventListener('load', () => {
    const base =
      typeof __PUBLIC_PATH__ !== 'undefined' ? String(__PUBLIC_PATH__) : '/';
    const prefix = base.endsWith('/') ? base : `${base}/`;
    navigator.serviceWorker.register(`${prefix}service-worker.js`).catch(() => {
      /* PWA optional */
    });
  });
}
